// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__23tmQ","layout--white":"Layout_layout--white__NS97p","layout--light-grey":"Layout_layout--light-grey__2u4Ky","layout__main":"Layout_layout__main__29zsa"};